import { MediaFile } from '@monogrid/vue-boost/cms'
import { Locale } from 'vue-i18n'

/**
 * Utility type for improving readability (by expanding object types one level deep)
 * It forces TS to recalculate the types and display their final and more readable form
 * For example, Omit<{ a: number, b: number }, 'a'> will be displayed as { b: number }
 */
export type Expand<T> = T extends infer O ? { [K in keyof O]: O[K] } : never

export type AccessibleImage = {
  alt: string
  data: MediaFile
}

export type Country = {
  code: string
  locales?: Locale[]
  name: string
}

export enum Theme {
  DARK = 'dark',
  DEFAULT = 'dark',
  LIGHT = 'light'
}
